<template>
  <v-sheet class="d-flex align-center pa-5 px-3" color="#f4f7fa" height="100%">
    <v-sheet class="mx-auto" color="transparent" max-width="720px">
      <Header />

      <div class="d-flex flex-column mt-3 mt-md-6 list">
        <v-card
          v-for="(
            { className, title, subtitle, icon, size, link, target, copyText },
            index
          ) in links"
          :key="index"
          class="pa-3 pa-sm-6 rounded-lg list-item"
          :class="className"
          :target="target"
          :href="link"
        >
          <div class="d-flex align-center list-item-content">
            <v-sheet
              class="d-flex align-center justify-center icon-container"
              height="48px"
              min-width="48px"
              width="48px"
              rounded="lg"
            >
              <v-icon class="icon-item" color="#000" :size="size">
                {{ icon }}
              </v-icon>
            </v-sheet>

            <div>
              <div class="text-subtitle-1 font-weight-medium">{{ title }}</div>
              <div
                class="grey--text text--darken-2 text-caption text-sm-body-2 font-weight-regular mt-n1"
              >
                {{ subtitle }}
              </div>
            </div>

            <div class="ml-auto show-when-hover">
              <v-tooltip :left="smAndDown" :bottom="!smAndDown">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click.prevent="copyClipboard(subtitle)"
                    v-bind="attrs"
                    v-on="on"
                    icon
                  >
                    <v-icon color="grey lighten-2" size="16">
                      mdi-file-multiple-outline
                    </v-icon>
                  </v-btn>
                </template>

                <span> {{ copyText }} </span>
              </v-tooltip>
            </div>
          </div>
        </v-card>
      </div>

      <Footer />
    </v-sheet>

    <v-snackbar v-model="snackbar" color="success" timeout="3000">
      Copiado para a área de transferência!

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" @click="snackbar = false" small icon>
          <v-icon size="14"> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-sheet>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";

export default {
  name: "HomeView",
  components: { Header, Footer },
  data: () => ({
    snackbar: false,
    links: [
      {
        className: "web-site",
        title: "Site Canto a Canto",
        subtitle: "cantoacanto.com.br",
        icon: "mdi-web",
        size: 28,
        link: "https://cantoacanto.com.br",
        target: "_blank",
        copyText: "Copiar link: cantoacanto.com.br",
      },
      {
        className: "whatsapp",
        title: "WhatsApp de atendimento 24h/7d",
        subtitle: "(66) 9 9939-3003",
        icon: "mdi-whatsapp",
        size: 28,
        link: "https://wa.me/+5566999393003?text=Olá, vim do site e estou a procura de um imóvel!",
        target: "_blank",
        copyText: "Copiar número de WhatsApp: (66) 9 9939-3003",
      },
      {
        className: "mapa",
        title: "Localização Canto a Canto",
        subtitle:
          "R. das Graviolas, N° 383 - Sala 09 - St. Comercial, Sinop - MT, 78550-136",
        icon: "mdi-map-marker-outline",
        size: 32,
        link: "https://maps.app.goo.gl/Dbg1mw9RaWbpVANE9",
        target: "_blank",
        copyText:
          "Copiar endereço: R. das Graviolas, N° 383 - Sala 09 - St. Comercial, Sinop - MT, 78550-136",
      },
    ],
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    copyClipboard(text) {
      navigator.clipboard.writeText(text);

      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  gap: 16px;
  overflow: visible;

  &-item {
    border: 2px solid #ffffff !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
    pointer-events: visibleFill;
    position: relative;
    transform: translateZ(0);
    transform-origin: center center;
    transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
    will-change: transform;

    &.web-site {
      .icon-container {
        background-color: #dbeafe !important;

        .icon-item {
          color: #155dfc !important;
        }
      }

      &:hover {
        border: 2px solid rgba(43, 127, 255, 0.5) !important;
      }
    }

    &.whatsapp {
      .icon-container {
        background-color: #dcfce7 !important;

        .icon-item {
          color: #00a63e !important;
        }
      }

      &:hover {
        border: 2px solid rgba(0, 201, 81, 0.5) !important;
      }
    }

    &.mapa {
      .icon-container {
        background-color: #ffe2e2 !important;

        .icon-item {
          color: #e7000b !important;
        }
      }

      &:hover {
        border: 2px solid rgba(251, 44, 54, 0.5) !important;
      }
    }

    &.phone {
      .icon-container {
        background-color: #fef3c6 !important;

        .icon-item {
          color: #e17100 !important;
        }
      }

      &:hover {
        border: 2px solid rgba(254, 154, 0, 0.5) !important;
      }
    }

    &-content {
      gap: 12px;
    }

    .show-when-hover {
      opacity: 0 !important;
      transition: all 0.18 ease;

      @media screen and (max-width: 959.9px) {
        opacity: 1 !important;
      }
    }

    &:hover {
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
      transform: scale(1.04);

      .show-when-hover {
        opacity: 1 !important;
      }
    }
  }
}
</style>
